
declare global {
    interface Window {
      OpenPay: any;
    }
  }

  export async function ensureOpenpayScripts(): Promise<void> {
    if (window.OpenPay) return;
    const load = (src: string) =>
      new Promise<void>((resolve, reject) => {
        const s = document.createElement("script");
        s.src = src;
        s.async = true;
        s.onload = () => resolve();
        s.onerror = () => reject(new Error(`No se pudo cargar: ${src}`));
        document.head.appendChild(s);
      });
  
    await load("https://js.openpay.mx/openpay.v1.min.js");
    await load("https://js.openpay.mx/openpay-data.v1.min.js");
  }
  
  export function initOpenpay(opts: {
    merchantId: string; 
    publicKey: string;
    sandbox?: boolean;
  }) {
    const { merchantId, publicKey, sandbox = true } = opts;
    window.OpenPay.setId(merchantId);
    window.OpenPay.setApiKey(publicKey);
    window.OpenPay.setSandboxMode(sandbox);
  }
  
  export function getDeviceSessionId(formOrElement: string | HTMLElement) {
    return window.OpenPay.deviceData.setup(formOrElement);
  }
  
  export type CardData = {
    card_number: string; 
    holder_name: string;
    expiration_year: string; 
    expiration_month: string;
    cvv2: string;
    address?: Record<string, any>;
  };
  
  export function createCardToken(card: CardData): Promise<{ id: string }> {
    return new Promise((resolve, reject) => {
      window.OpenPay.token.create(
        card,
        (ok: any) => resolve({ id: ok.data.id }),
        (err: any) => reject(err)
      );
    });
  }
  